import { appDownloadSection } from './shared';
import type { IconName } from './types';

export const sendMoneyHero = {
  title: 'Send money home\nat the best rates',
};

/*
 * The currency-rate strip's pairs and values are now derived live from the
 * calculator's supported currencies (see CurrencyRatesStrip + src/lib/quote.ts),
 * so the former hardcoded `sendMoneyRates` / `CurrencyRatePair` demo data has
 * been removed.
 */

/** Hero left-column feature rows (Figma send-money-home). */
export const sendMoneyHeroFeatures: { icon: IconName; title: string; description: string }[] = [
  {
    icon: 'percent',
    title: 'Keep your earnings',
    description: 'Withdraw at our best rates and lowest fees',
  },
  {
    icon: 'shuffle',
    title: 'The fastest transfers',
    description: 'Watch your money arrive even faster.',
  },
];

/** Re-exported shared "Download the nsave app" block (see content/shared). */
export const sendMoneyDownload = appDownloadSection;
